import * as S from './styles';

import PanelOptionMixin from '../mixin';

import Switch from '@components/Common/Switch';
import Dialog from '@/components/Common/Dialog';

import BlendIcon from '@svgIcons/dashboard/row_column_edit.svg';
import InfoLineIcon from '@svgIcons/widget_info.svg';

export default {
    name: 'BlendSettingToggleOption',
    mixins: [PanelOptionMixin],
    props: {
        isAnalytic: { type: Boolean },
        isCustomWidget: { type: Boolean },
    },
    data() {
        return {
            active: false,
        };
    },
    methods: {
        setActive(value) {
            this.active = value;
        },
    },
    render() {
        const { isAnalytic, isCustomWidget, active, setActive } = this;

        const dialogProps = {
            attrs: {
                active,
                backdrop: true,
                newDesign: true,
                confirmText: this.$t(
                    'NEW_DASHBOARD.blend_setting_toggle_option_dialog_confirm_button'
                ),
                cancelText: this.$t(
                    'NEW_DASHBOARD.blend_setting_toggle_option_dialog_cancel_button'
                ),
            },
            on: {
                'update:active': setActive,
                confirm: () => {
                    this.$emit('update', !isCustomWidget);
                    setActive(false);
                },
                cancel: () => setActive(false),
            },
        };

        return (
            <S.ComponentWrapper>
                <div class="top-wrapper">
                    <div class="title">
                        <BlendIcon v-view-box class="blend-icon" />
                        <h3>
                            {this.$t(
                                'NEW_DASHBOARD.integration_setting_option.title'
                            )}
                        </h3>
                        {this.wrapTooltip({
                            visible: true,
                            content: <InfoLineIcon class="info-line-icon" />,
                            title: this.$t(
                                'NEW_DASHBOARD.integration_setting_option.tooltip'
                            ),
                        })}
                    </div>
                    <Switch
                        value={!isAnalytic}
                        type="big"
                        onClick={() => setActive(true)}
                    />
                    <portal to="panel_modal_second">
                        <Dialog {...dialogProps}>
                            <S.DialogContent>
                                <S.DialogTitle>
                                    {this.$t(
                                        'NEW_DASHBOARD.integration_setting_option.dialog_title'
                                    )}
                                </S.DialogTitle>
                                <S.DialogDesc>
                                    {this.$t(
                                        'NEW_DASHBOARD.integration_setting_option.dialog_desc'
                                    )}
                                </S.DialogDesc>
                            </S.DialogContent>
                        </Dialog>
                    </portal>
                </div>
            </S.ComponentWrapper>
        );
    },
};
